import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  InputGroup,
  Card,
} from "react-bootstrap";
import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import axios from "axios";
import AppContext from "../../../context/Appcontext";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

const CreateCourse = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  /*===================================  STATES  ===================================*/
  const [courseIdForUpdate, setCourseIdForUpdate] = useState(null);
  const [courseImage, setCourseImage] = useState(null);
  const [imageForEdit, setImageForEdit] = useState("");
  const [courseName, setCourseName] = useState("");
  const [courseDescription, setCourseDescription] = useState("");
  const [courseDuration, setCourseDuration] = useState("");
  const [lessons, setLessons] = useState("");
  const [certificate, setCertificate] = useState("");
  const [category, setCategory] = useState("");
  const [level, setLevel] = useState("");
  const [price, setPrice] = useState("");
  const [discountPrice, setDiscountPrice] = useState("");
  const [slug, setSlug] = useState("");
  const [tags, setTags] = useState("");
  const [visibility, setVisibility] = useState("public");
  const [status, setStatus] = useState("draft");
  const [courses, setCourses] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    viewAllCourses();
  }, []);

  /*===================================  API CALLS  ===================================*/

  const viewAllCourses = () => {
    axios
      .get(`${baseUrl}/admin/course/viewAllCourses`)
      .then((response) => {
        setCourses(response.data.courses || []);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const createCourse = () => {
    const formdata = new FormData();
    formdata.append("courseImage", courseImage);
    formdata.append("courseName", courseName);
    formdata.append("courseDescription", courseDescription);
    formdata.append("courseDuration", courseDuration);
    formdata.append("lessons", lessons);
    formdata.append("certificate", certificate);
    formdata.append("category", category);
    formdata.append("level", level);
    formdata.append("price", price);
    formdata.append("discount_price", discountPrice);
    formdata.append("slug", slug);
    formdata.append("tags", tags);
    formdata.append("visibility", visibility);
    formdata.append("status", status);

    axios
      .post(`${baseUrl}/admin/course/createCourse`, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response);
        alert("Course created!");
        // Swal.fire({
        //   title : "Congratulations!"
        // })
        viewAllCourses();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const updateCourse = () => {
    const formdata = new FormData();
    formdata.append("courseId", courseIdForUpdate);
    formdata.append("courseImage", courseImage);
    formdata.append("courseName", courseName);
    formdata.append("courseDescription", courseDescription);
    formdata.append("courseDuration", courseDuration);
    formdata.append("lessons", lessons);
    formdata.append("certificate", certificate);
    formdata.append("category", category);
    formdata.append("level", level);
    formdata.append("price", price);
    formdata.append("discount_price", discountPrice);
    formdata.append("slug", slug);
    formdata.append("tags", tags);
    formdata.append("visibility", visibility);
    formdata.append("status", status);

    axios
      .post(`${baseUrl}/admin/course/updateCourse`, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response);
        alert("Course updated!");
        viewAllCourses();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const deleteCourse = (id) => {
    if (!window.confirm("Delete this course?")) return;
    axios
      .post(`${baseUrl}/admin/course/deleteCourse/${id}`)
      .then((response) => {
        console.log(response);
        viewAllCourses();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  /*===================================  JSX  ===================================*/

  return (
    <AdminLayout>
      <Container>
        {/* ── FORM ── */}
        <Card className="mb-4 mt-4">
          <Card.Body>
            <h3>{courseIdForUpdate ? "Update Course" : "Add New Course"}</h3>
            <Form>
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Course Image</Form.Label>
                    {imageForEdit ? (
                      <img
                        src={`${baseUrlForFiles}/${imageForEdit}`}
                        style={{ height: 80, width: 120, display: "block", marginBottom: 8, borderRadius: 6, objectFit: "cover" }}
                      />
                    ) : null}
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => setCourseImage(e.target.files[0])}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Course Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={courseName}
                      onChange={(e) => setCourseName(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Category</Form.Label>
                    <Form.Select value={category} onChange={(e) => setCategory(e.target.value)}>
                      <option value="">Select Category</option>
                      <option>Web Development</option>
                      <option>Mobile Development</option>
                      <option>Data Science</option>
                      <option>UI/UX Design</option>
                      <option>DevOps</option>
                      <option>Cybersecurity</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Level</Form.Label>
                    <Form.Select value={level} onChange={(e) => setLevel(e.target.value)}>
                      <option value="">Select Level</option>
                      <option>Beginner</option>
                      <option>Intermediate</option>
                      <option>Advanced</option>
                      <option>All Levels</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Duration</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g. 8 weeks"
                      value={courseDuration}
                      onChange={(e) => setCourseDuration(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Lessons</Form.Label>
                    <Form.Control
                      type="number"
                      value={lessons}
                      onChange={(e) => setLessons(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Certificate</Form.Label>
                    <Form.Select value={certificate} onChange={(e) => setCertificate(e.target.value)}>
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Price ($)</Form.Label>
                    <Form.Control
                      type="number"
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Discount Price ($)</Form.Label>
                    <Form.Control
                      type="number"
                      value={discountPrice}
                      onChange={(e) => setDiscountPrice(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Slug</Form.Label>
                    <Form.Control
                      type="text"
                      value={slug}
                      onChange={(e) => setSlug(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tags</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g. react, js"
                      value={tags}
                      onChange={(e) => setTags(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Visibility</Form.Label>
                    <Form.Select value={visibility} onChange={(e) => setVisibility(e.target.value)}>
                      <option value="public">Public</option>
                      <option value="private">Private</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                      <option value="draft">Draft</option>
                      <option value="published">Published</option>
                      <option value="pending_review">Pending Review</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={courseDescription}
                      onChange={(e) => setCourseDescription(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex gap-2">
                <Button
                  onClick={() => {
                    if (courseIdForUpdate == null) {
                      createCourse();
                    } else {
                      updateCourse();
                    }
                  }}
                >
                  <FaPlus className="me-2" />
                  {courseIdForUpdate == null ? "Add Course" : "Update Course"}
                </Button>
                {courseIdForUpdate && (
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setCourseIdForUpdate(null);
                      setCourseImage(null);
                      setImageForEdit("");
                      setCourseName("");
                      setCourseDescription("");
                      setCourseDuration("");
                      setLessons("");
                      setCertificate("");
                      setCategory("");
                      setLevel("");
                      setPrice("");
                      setDiscountPrice("");
                      setSlug("");
                      setTags("");
                      setVisibility("public");
                      setStatus("draft");
                    }}
                  >
                    Cancel
                  </Button>
                )}
              </div>
            </Form>
          </Card.Body>
        </Card>

        {/* ── TABLE ── */}
        <Card>
          <Card.Body className="p-0">
            <div className="d-flex justify-content-between align-items-center p-3">
              <h3 className="mb-0">All Courses</h3>
              <InputGroup style={{ width: 250 }}>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </InputGroup>
            </div>

            <Table hover responsive>
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Level</th>
                  <th>Price</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {courses.length > 0 ? (
                  courses
                    .filter((c) =>
                      c.courseName?.toLowerCase().includes(searchQuery.toLowerCase())
                    )
                    .map((course) => (
                      <tr key={course.id}>
                        <td>
                          {course.courseImage ? (
                            <img
                              src={`${baseUrlForFiles}/${course.courseImage}`}
                              alt="course"
                              width="60"
                              height="40"
                              style={{ objectFit: "cover", borderRadius: 6 }}
                            />
                          ) : (
                            <span className="text-muted">No Image</span>
                          )}
                        </td>
                        <td>{course.courseName}</td>
                        <td>{course.category || "-"}</td>
                        <td>{course.level || "-"}</td>
                        <td>{course.price ? `$${course.price}` : "Free"}</td>
                        <td>{course.status || "draft"}</td>
                        <td>
                          <div className="d-flex gap-2">
                            <Button
                              size="sm"
                              variant="warning"
                              onClick={() => {
                                setCourseIdForUpdate(course.id);
                                setCourseName(course.courseName || "");
                                setCourseDescription(course.courseDescription || "");
                                setCourseDuration(course.courseDuration || "");
                                setLessons(course.lessons || "");
                                setCertificate(course.certificate || "");
                                setCategory(course.category || "");
                                setLevel(course.level || "");
                                setPrice(course.price || "");
                                setDiscountPrice(course.discount_price || "");
                                setSlug(course.slug || "");
                                setTags(course.tags || "");
                                setVisibility(course.visibility || "public");
                                setStatus(course.status || "draft");
                                setImageForEdit(course.courseImage || "");
                                window.scrollTo({ top: 0, behavior: "smooth" });
                              }}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => deleteCourse(course.id)}
                            >
                              <FaTrash />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      No courses found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Container>
    </AdminLayout>
  );
};

export default CreateCourse;